
  
 
  
  export const clearTokens = () => {
    localStorage.clear();
    localStorage.clear();
  };